import { useMutation } from "@tanstack/react-query";
import { getCreditReportApi } from "../api/credit";
import { useAppSystem } from "./useAppSystem";
import { creditReportState } from "../store/data/creditReport";
import { refreshEvent } from "../api/inventory";
import { vendorUUIDs } from "../config/constants";

export function useGlobalApis() {
  const { teamConfig, dispatch } = useAppSystem();
  const { teamSchema, platform, refreshInventoryWhenEventClick } = teamConfig;
  const getCreditReport = useMutation(getCreditReportApi);
  const refreshEventMutation = useMutation(refreshEvent);

  const handleGetCreditReport = async () => {
    try {
      const { data } = await getCreditReport.mutateAsync({
        teamSchema,
      });
      dispatch(creditReportState.actions.set(data));
    } catch (error) {
      console.log(error);
    }
  };

  const handleRefreshEvent = async (eventCode: string) => {
    if (
      refreshInventoryWhenEventClick &&
      platform === vendorUUIDs.tickesdotcom
    ) {
      refreshEventMutation.mutateAsync({
        teamSchema,
        eventCode,
      });
    }
  };

  return {
    handleGetCreditReport,
    getCreditReport,
    handleRefreshEvent,
  };
}
